<template lang="pug">
  .approved-switch(@click.stop="onSwitch()")
    input(type="checkbox" v-model="_value")
    label.switch-label()
      span
    .switch-img
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### 受付済/未受付を切り替えるスイッチコンポーネント
 */
@Component
export default class ApprovedSwitch extends Vue {
  /**
   * 親コンポーネントから受け取るスイッチの値
   */
  @Prop({
    default: () => {
      return false;
    }
  })
  value!: boolean;

  get _value(): boolean {
    return this.value;
  }

  public onSwitch(): void {
    this.$emit("input", !this.value);
    this.$emit("onSwitch");
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/pc/_colors.scss";

// ボタン領域
.approved-switch {
  line-height: 34px;
  letter-spacing: 0;
  text-align: center;
  position: relative;
  width: 94px;

  // チェックボックス
  input[type="checkbox"] {
    display: none;
  }

  // リンクであることが分かるようにカーソルを変える
  cursor: pointer;

  // ラベル
  label.switch-label {
    display: block;
    box-sizing: border-box;
    height: 36px;
    border: 2px solid $switch-bordercolor;
    border-radius: 4px;
    font-size: 16px;
    background: rgba(255, 255, 255, 1);
    margin-bottom: 0;
    // リンクであることが分かるようにカーソルを変える
    cursor: pointer;
  }

  // ラベル(ON)
  input[type="checkbox"]:checked + label {
    // ON時の枠線
    border-color: $btn-selected;
  }

  // 表示する文字(OFF)
  label span:after {
    content: "未受付";
    padding: 0 0 0 28px;
    color: $switch-bordercolor;
  }

  // 表示する文字(ON)
  input[type="checkbox"]:checked + label span:after {
    content: "受付済";
    padding: 0 28px 0 0;
    color: $btn-selected;
  }

  // トグル部分
  .switch-img {
    position: absolute;
    width: 28px;
    height: 28px;
    background: $switch-bordercolor;
    top: 4px;
    left: 4px;
    border-radius: 2px;
    transition: 0.4s;
  }

  // トグル部分(ON)
  input[type="checkbox"]:checked ~ .switch-img {
    transform: translateX(58px);
    background: $btn-selected;
  }
}
</style>
